import React, { ReactElement } from 'react';

const ColumnWrapper = (props): ReactElement => (
  <div className="column is-half-desktop is-four-fifths-mobile is-half-tablet is-flex is-flex-direction-column is-justify-content-center is-align-items-center">
    {props.children}
  </div>
);

export default ColumnWrapper;
